import React from 'react';
import {
    List,
    SingleFieldList,
    ChipField,
    CheckboxGroupInput ,
    Pagination,
    Datagrid,
    TextField,
    // ArrayField,
    Show,
    SimpleShowLayout,
    ReferenceField,
    ReferenceArrayField,
    Edit,
    EditButton,
    SimpleForm,
    TextInput,
    SelectArrayInput,
    ReferenceInput,
    ReferenceArrayInput,
    SelectInput,
    Create,
    FormDataConsumer,
} from 'react-admin';

export const HEXSelectorPlateList = (props) => (
    <List title="Plates" {...props} pagination={<Pagination rowsPerPageOptions={[10,25,100,500]} />}>
        <Datagrid>
            <TextField source="name" />
            <ReferenceField source="typeId" reference="HEXSelector/ExchangerTypes">
                <TextField source="type"></TextField>
            </ReferenceField>
            <EditButton></EditButton>
        </Datagrid>
    </List>
);

export const HEXSelectorPlateEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <ReferenceInput label="Heat Exchanger Type" source="typeId" reference="HEXSelector/ExchangerTypes">
                <SelectInput optionText="type" />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);

export const HEXSelectorPlateCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <ReferenceInput label="Heat Exchanger Type" source="typeId" reference="HEXSelector/ExchangerTypes">
                <SelectInput optionText="type" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);

export const HEXSelectorPlateListsList = (props) => (
    <List title="User Groups" {...props} pagination={<Pagination rowsPerPageOptions={[10,25,50,100]} />}>
        <Datagrid style={{ marginLeft: '12px', marginRight: '12px' }}>
            <TextField source="name" />
            <ReferenceArrayField label="Plate Lists" reference="HEXSelector/PlateTypeLists" source="plateTypeList_ids" sortable={false} perPage={1000}>
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>                        
            </ReferenceArrayField>
            <EditButton />
        </Datagrid>
    </List>
);

export const HEXSelectorPlateListsCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <ReferenceArrayInput label="Plate Lists" reference="HEXSelector/PlateTypeLists" source="plateTypeList_ids" sortable={false} perPage={1000}>
            <SelectArrayInput>
                <ChipField source="name" />
            </SelectArrayInput>
            </ReferenceArrayInput>
        </SimpleForm>
    </Create>
);

export const HEXSelectorPlateListsEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <ReferenceArrayInput label="Plate Lists" reference="HEXSelector/PlateTypeLists" source="plateTypeList_ids" perPage={1000}>
            <SelectArrayInput>
                   <ChipField source="name" />
                </SelectArrayInput>
            </ReferenceArrayInput>
        </SimpleForm>
    </Edit>
);

export const HEXSelectorPlateListsShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="name" />
            <ReferenceArrayField label="Plate Lists" reference="HEXSelector/PlateTypeLists" source="plateTypeList_ids" perPage={1000}>
                <Datagrid>
                    <TextField source="name" />
                    <TextField source="type" />
                    <ReferenceArrayField label="Plates" reference="HEXSelector/PlateTypeNames" source="plateTypeName_ids" perPage={1000}>
                        <SingleFieldList>
                            <ChipField source="name" />
                        </SingleFieldList>
                    </ReferenceArrayField>
                </Datagrid>
            </ReferenceArrayField>
        </SimpleShowLayout>
    </Show>
);

export const HEXSelectorPlateTypeListsList = (props) => (
    <List title="Plate Type Lists" {...props} pagination={<Pagination rowsPerPageOptions={[10,25,50,100,250,500]} />}>
        <Datagrid style={{ marginLeft: '12px', marginRight: '12px' }}>
            <TextField source="name" />
            <ReferenceField source="typeId" reference="HEXSelector/ExchangerTypes">
                <TextField source="type"></TextField>
            </ReferenceField>
            <ReferenceArrayField label="Plates" reference="HEXSelector/PlateTypeNames" source="plateTypeName_ids" perPage={1000}>
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>
            </ReferenceArrayField>
            <EditButton />
        </Datagrid>
    </List>
);

export const HEXSelectorPlateTypeListsShow = (props) => (
    <Show {...props} >
        <SimpleShowLayout>
            <TextField source="name" />
            <ReferenceField source="typeId" reference="HEXSelector/ExchangerTypes">
                <TextField source="type"></TextField>
            </ReferenceField>
            <ReferenceArrayField label="Plates" reference="HEXSelector/PlateTypeNames" source="plateTypeName_ids" perPage={1000}>
            <SingleFieldList>
               <ChipField source="name" />
            </SingleFieldList>
        </ReferenceArrayField>
       </SimpleShowLayout>
   </Show>
);

export const HEXSelectorPlateTypeListsEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="name"></TextInput>
            <ReferenceInput label="Heat Exchanger Type" source="typeId" reference="HEXSelector/ExchangerTypes">
                <SelectInput optionText="type" />
            </ReferenceInput>
            {/* <SelectInput  source="type" choices={[{id:'Brazed', name:'Brazed'},{id:'Gasketed',name:'Gasketed'}]} /> */}
            <FormDataConsumer>
                {({ formData, ...rest }) => 
                <ReferenceArrayInput
                    perPage={1000}
                    label="Plates"
                    reference="HEXSelector/PlateTypeNames"
                    source="plateTypeName_ids"
                    filter={{ ofType: formData.typeId }}
                    >
                        <CheckboxGroupInput >
                            <ChipField source="name"/>
                        </CheckboxGroupInput >
                    </ReferenceArrayInput>
                 }            
            </FormDataConsumer>
       </SimpleForm>
    </Edit>
);

export const HEXSelectorPlateTypeListsCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name"></TextInput>
            <ReferenceInput label="Heat Exchanger Type" source="typeId" reference="HEXSelector/ExchangerTypes">
                <SelectInput optionText="type" />
            </ReferenceInput>
            {/* <Button onClick={() => console.log(props)}>Select All</Button> */}
            <FormDataConsumer>
                {({ formData, ...rest }) => 
                <ReferenceArrayInput
                    perPage={1000}
                    label="Plates"
                    reference="HEXSelector/PlateTypeNames"
                    resource="HEXSelector/PlateTypeNames"
                    source="plateTypeName_ids"
                    filter={{ ofType: formData.typeId }}
                    >
                        <CheckboxGroupInput >
                            <ChipField source="name"/>
                        </CheckboxGroupInput >
                    </ReferenceArrayInput>
                 }            
            </FormDataConsumer>
       </SimpleForm>
    </Create>
);